import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "  Zanzar", -1)
const _hoisted_3 = { class: "float-right d-none d-sm-inline-block" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("strong", null, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.copyright")) + " © " + _toDisplayString(_ctx.currentYear), 1),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("b", null, _toDisplayString(_ctx.$t("labels.version")), 1),
      _createElementVNode("span", null, ": " + _toDisplayString(_ctx.version), 1)
    ])
  ]))
}